module.exports = __webpack_public_path__ + "img/975f074.png";